module.exports = __webpack_public_path__ + "img/Speaker=Leonard Lee.c8457423.png";